import {Component} from '@angular/core';
import {MatCheckboxChange} from '@angular/material/checkbox';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {ScheduleItem} from '../../../custom-components/calendar-timeline/schedule-item.interface';
import {CheckboxCellEditorParams} from './checkbox-cell-editor-params.interface';

@Component({
  templateUrl: './checkbox-cell-editor.component.html',
  styleUrls: ['./checkbox-cell-editor.component.scss']
})
export class CheckboxCellEditorComponent implements ICellRendererAngularComp {
  public params: CheckboxCellEditorParams;

  public agInit(params: CheckboxCellEditorParams): void {
    this.params = params;

    if (this.params.canSetRowSelected) {
      this.canShowIndeterminate();
    }
  }

  public valueChanged(event: MatCheckboxChange): void {
    this.params.setValue(event.checked);

    if (this.params.canSetRowSelected) {
      this.params.value = event.checked;
      this.params.node.setSelected(event.checked);
      this.params.data[this.params.selectedItemListName].forEach((scheduleItem: ScheduleItem) => (scheduleItem.selected = event.checked));
      this.params.api.refreshCells({rowNodes: [this.params.node], force: true});
      this.params.api.refreshHeader();
    }
  }

  public refresh(_: ICellRendererParams<any, any>): boolean {
    if (this.params.canSetRowSelected) {
      this.params.value = this.params.node.isSelected();
      this.canShowIndeterminate();
    }

    return true;
  }

  private canShowIndeterminate(): void {
    const listOfItems = this.params.data[this.params.selectedItemListName];
    const selectedItemsLength = listOfItems.filter((scheduleItem: ScheduleItem) => scheduleItem.selected).length;
    this.params.canShowIndeterminate = selectedItemsLength > 0 && selectedItemsLength !== listOfItems.length;

    if (listOfItems.length > 0 && selectedItemsLength === 0) {
      this.params.value = false;
      this.params.node.setSelected(false);
      this.params.api.refreshCells({columns: [this.params.selectedItemListName], rowNodes: [this.params.node], force: true});
    }
  }
}
